<div class="row page-header">
    <div class="col-12">
        <h1>Monthly Plans <small>Enter planned revenues and profits/gross margins for each month of the year</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                        ></action-toolbar-buttons>
                        <grid-export [grid]="mainGrid" [name]="'Monthly Plans'"></grid-export>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        [padding]="73"
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column
                            [header]="'Month/Year'"
                            [binding]="'date'"
                            [format]="'MMM yyyy'"
                            [width]="'*'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Plan Revenue'"
                            [binding]="'revenue'"
                            [format]="'C0'"
                            [width]="'*'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Plan Profit/Gross Margin'"
                            [binding]="'profit'"
                            [format]="'C0'"
                            [width]="'*'"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                    <grid-selection-calculation [grid]="mainGrid"></grid-selection-calculation>
                </div>
            </div>
        </div>
    </div>
</div>
